import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "components/common/Modal";
import { Button } from "components/common/Button";
import { NumberInput } from "components/common/NumberInput";
import type { PageCalibrationModalProps } from "./types";

export const PageCalibrationModal = ({
  isOpen,
  pdfDistance,
  isSubmitting,
  onSubmit,
  onCancel,
}: PageCalibrationModalProps) => {
  const { t } = useTranslation();
  const [realMeters, setRealMeters] = useState(0);

  const isSubmitDisabled = isSubmitting || realMeters <= 0 || pdfDistance <= 0;

  useEffect(() => {
    if (isOpen) setRealMeters(0);
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onCancel} size="sm">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">
        {t("smartSurveyor.pageCalibration.title")}
      </h2>
      <p className="text-sm text-gray-600 mb-3">
        {t("smartSurveyor.pageCalibration.description")}
      </p>
      <div className="text-xs text-gray-500 mb-3">
        {t("smartSurveyor.pageCalibration.pdfDistanceLabel")}:{" "}
        {pdfDistance.toFixed(2)} pt
      </div>
      <div className="space-y-1">
        <label className="text-xs text-gray-700">
          {t("smartSurveyor.pageCalibration.realMetersLabel")}
        </label>
        <NumberInput
          value={realMeters}
          onChange={setRealMeters}
          step={0.1}
          min={0}
        />
      </div>
      <div className="flex justify-end gap-3 mt-6">
        <Button
          size="lg"
          className="flex-1"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          {t("smartSurveyor.common.cancel")}
        </Button>
        <Button
          variant="primary"
          size="lg"
          className="flex-1"
          onClick={() => onSubmit(realMeters)}
          disabled={isSubmitDisabled}
        >
          {isSubmitting
            ? t("smartSurveyor.pageCalibration.saving")
            : t("smartSurveyor.pageCalibration.apply")}
        </Button>
      </div>
    </Modal>
  );
};
